import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import orderBy from "lodash/orderBy";
import Container from "reactstrap/lib/Container";
import { Col } from "ComponentsUI/Styles/Grid";
import Row from "reactstrap/lib/Row";
import { EmptyStub } from "ComponentsUI/EmptyStub";
import chunk from "lodash/chunk";
import { LeftArrow, RightArrow } from "ComponentsUI/CarouselComponents";
import Carousel from "nuka-carousel";
import { v4 } from "uuid";
import { isMoscowSiteCode } from "Utils/siteConfig";

const styles = (theme) => ({
	root: {
		minHeight: "100vh",
	},
	wrapper: {
		paddingTop: "60px",
		height: "100vh",
		// minHeight: "940px",
		display: "flex",
		flexWrap: "wrap",
	},
	wrapper101: {
		minHeight: "940px",
	},
	close: {
		position: "absolute",
		right: "50px",
		top: "50px",
		width: "60px",
		height: "60px",
		borderRadius: "50%",
		border: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer",
		"& span": {
			fontSize: "20px",
			color: theme.palette.colors.lightGrayishViolet,
		},
	},
	notMount: {
		height: "auto !important",
		"& $citiesList": {
			height: "auto !important",
			marginTop: "20px",
			display: "flex",
			justifyContent: "center",
		},
	},
	headerWrapper: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "flex-start",
		width: "100%",
	},
	header: {
		display: "flex",
		alignItems: "flex-start",
	},
	dashed: {},
	mainHeader: {
		fontFamily: theme.fonts.bold,
		fontSize: "36px",
		lineHeight: 1,
		color: theme.palette.colors.darkSlateBlue,
		marginRight: "auto",
		"& span": {
			cursor: "pointer",
			position: "relative",
			paddingBottom: "10px",
			borderBottom: `3px solid ${theme.palette.colors.purplishBlue}`,
			"&$dashed": {
				paddingBottom: "10px",
				borderBottom: `3px dotted ${theme.palette.colors.purplishBlue}`,
			},
		},
	},
	search: {
		marginRight: "40px",
		width: "240px",
		paddingBottom: "13px",
		borderBottom: `1px solid ${theme.palette.colors.lightGrayishViolet}`,
		display: "flex",
		alignItems: "center",
		marginTop: "14px",
		marginBottom: "10px",
		"& svg": {
			width: "24px",
			height: "24px",
			fill: theme.palette.colors.cloudyBlue,
			marginRight: "12px",
		},
		"& span": {
			position: "absolute",
			marginTop: "38px",
			color: theme.palette.colors.spanishGrey,
			fontSize: "1.05em",
		},
	},
	searchInput: {
		backgroundColor: theme.palette.colors.transparent,
		border: "none",
		appearance: "none",
		fontFamily: theme.fonts.medium,
		color: theme.palette.colors.purplishBlue,
		fontSize: "16px",
		width: "100%",
		flexShrink: 100,
	},
	citiesList: {
		height: "640px",
		width: "100%",
		"& .slider": {
			position: "static !important",
		},
		"& .slider-decorator-1": {
			right: "-100px !important",
		},
		"& .slider-decorator-0": {
			left: "-100px !important",
		},
		"& .components__slider-button": {
			cursor: "pointer",
			width: "60px",
			height: "60px",
			borderRadius: "50%",
			border: `1px solid ${theme.palette.colors.purplishBlue}`,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			"& span": {
				fontSize: "24px",
				color: theme.palette.colors.purplishBlue,
			},
		},
	},
	otherCitiesList: {
		height: "60vh",
	},
	carouselItem: {
		display: "flex",
		flexDirection: "row",
	},
	col: {
		height: "100%",
		width: "450px",
		flexShrink: 0,
		paddingLeft: "30px",
	},
	colRegion: {},
	block: {
		marginBottom: "36px",
		position: "relative",
	},
	blockItemName: {
		fontFamily: theme.fonts.bold,
		fontSize: "16px",
		lineHeight: 2.25,
		color: theme.palette.colors.addressBlackHeader,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipses",
		paddingRight: "20px",
		display: "block",
		marginTop: "52px",
		marginBottom: "20px",
	},
	blockItem: {
		fontFamily: theme.fonts.medium,
		fontSize: "16px",
		lineHeight: 2.25,
		color: theme.palette.colors.purplishBlue,
		cursor: "pointer",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipses",
		paddingRight: "20px",
		display: "block",
	},
	blockNote: {
		fontFamily: theme.fonts.bold,
		fontSize: "16px",
		lineHeight: 2.25,
		color: theme.palette.colors.addressBlackHeader,
		position: "absolute",
		left: "-30px",
		top: 0,
		"& span": {
			fontSize: "13px",
			color: theme.palette.colors.addressBlackHeader,
		},
	},
	blockImportant: {
		marginBottom: "72px",
		"& $blockItem": {
			fontFamily: theme.fonts.bold,
		},
	},
	blockImportantMoskov: {
		marginBottom: "12px",
		"& $blockItem": {
			fontFamily: theme.fonts.bold,
		},
	},
	footer: {
		display: "flex",
		justifyContent: "flex-start",
		paddingBottom: "70px",
		paddingTop: "30px",
		alignSelf: "flex-end",
		width: "100%",
	},
	footerItem: {
		fontFamily: theme.fonts.medium,
		fontSize: "16px",
		lineHeight: 1.13,
		color: theme.palette.colors.oneMoreGrey,
		marginRight: "25px",
		textTransform: "uppercase",
		cursor: "pointer",
	},
	footerItemAll: {
		margin: "0 auto",
	},
	isActive: {
		color: theme.palette.colors.purplishBlue,
	},
	np: {
		fontSize: "30px",
		lineHeight: 1.2,
		marginRight: 0,
		color: "#2b1d5d",
	},
	phoneNumber: {
		whiteSpace: "nowrap",
		fontFamily: theme.fonts.bold,
		fontSize: "18px",
		lineHeight: "1.11",
		color: theme.palette.colors.darkSlateBlue,
		marginTop: "5px",
	},
	displayNone: {
		display: "none",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		search: {
			marginRight: "10px",
		},
		citiesList: {
			height: "640px",
			width: "100%",
		},
		otherCitiesList: {
			height: "60vh",
		},
		col: {
			width: "300px",
		},
		colRegion: {
			width: "38%",
		},
		footerItem: {
			marginRight: "20px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		wrapper: {
			paddingTop: "41px",
			height: "auto",
			// minHeight: 0
		},
		wrapper101: {
			minHeight: 0,
		},
		close: {
			top: "30px",
			right: "30px",
		},
		headerWrapper: {
			justifyContent: "center",
			flexWrap: "wrap",
		},
		header: {
			width: "100%",
			justifyContent: "center",
			textAlign: "center",
		},
		dashed: {},
		mainHeader: {
			fontSize: "30px",
			lineHeight: 1.2,
			marginRight: 0,
			"& span": {
				paddingBottom: "3px",
				borderBottom: `2px solid ${theme.palette.colors.purplishBlue}`,
				"&$dashed": {
					paddingBottom: "3px",
				},
			},
		},
		search: {
			marginRight: 0,
			width: "230px",
			marginTop: "42px",
		},
		citiesList: {
			height: "auto",
			width: "100%",
			paddingTop: "30px",
		},
		carouselItem: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "flex-start",
			paddingLeft: "240px",
		},
		col: {
			height: "auto",
			width: "350px",
			paddingLeft: 0,
		},
		block: {
			display: "flex",
			flexWrap: "wrap",
			width: "100%",
			alignItems: "flex-start",
		},
		blockItem: {
			width: "50%",
		},
		blockNote: {
			left: "-60px",
		},
		blockItemName: {
			width: "50%",
			marginTop: "36px",
			marginBottom: "16px",
		},
		blockImportantMoskov: {
			marginBottom: "12px",
		},
		blockImportant: {
			marginBottom: "36px",
		},
		colRegion: {
			width: "100%",
			"& $blockItem": {
				width: "100%",
			},
		},
		footer: {
			display: "none",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		wrapper: {
			paddingTop: "30px",
			height: "auto",
			// minHeight: 0
		},
		wrapper101: {
			minHeight: 0,
		},
		close: {
			top: "20px",
			right: "20px",
			border: "none",
			width: "auto",
			height: "auto",
			"& span": {
				fontSize: "16px",
			},
		},
		headerWrapper: {
			justifyContent: "left",
			flexWrap: "wrap",
			padding: "0 8.33%",
		},
		header: {
			width: "80%",
			textAlign: "left",
		},
		dashed: {},
		mainHeader: {
			fontSize: "20px",
			lineHeight: 1.25,
			marginRight: 0,
			"& span": {
				paddingBottom: "1px",
				borderBottom: `2px solid ${theme.palette.colors.purplishBlue}`,
				"&$dashed": {
					paddingBottom: "1px",
				},
			},
		},
		search: {
			marginRight: 0,
			width: "100%",
			marginTop: "35px",
		},
		citiesList: {
			height: "auto",
			width: "100%",
			paddingTop: "10px",
		},
		carouselItem: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "flex-start",
			padding: "0 8.33%",
		},
		col: {
			height: "auto",
			width: "100%",
			paddingLeft: 0,
		},
		block: {
			display: "flex",
			flexWrap: "wrap",
			width: "100%",
			alignItems: "flex-start",
			paddingLeft: "0",
			marginBottom: "16px",
		},
		blockItem: {
			width: "100%",
			paddingRight: 0,
		},
		blockNote: {
			position: "relative",
			left: 0,
		},
		blockItemName: {
			width: "100%",
			paddingRight: 0,
			marginTop: "16px",
			marginBottom: "0px",
		},
		blockImportantMoskov: {
			marginBottom: "0px",
		},
		blockImportant: {
			marginBottom: "36px",
		},
		footer: {
			display: "none",
		},
	},
});

class SwitchCityLayout extends React.PureComponent {
	static defaultProps = {
		onItemSelect: () => {},
	};

	constructor(props) {
		super(props);
		this.state = {
			wasMount: false,
			// searcheValue: "",
			letterValue: "",
		};
	}

	findChangeHandler(e) {
		this.props.findChangeHandler(e);
	}

	// setSearcheValue(value) {
	//     this.setState({
	//         ...this.state,
	//         searcheValue: value,
	//         letterValue: ""
	//     });
	// }

	setLettersValue(value) {
		this.setState({
			...this.state,
			letterValue: value,
		});
		this.props.findChangeHandler();
	}

	//
	getRenderRegions() {
		let siteCode = this.props.ApplicationModel.siteCode;
		if (isMoscowSiteCode(siteCode)) {
			if (this.props.moskovskayaoOblastCities) {
				return this.props.moskovskayaoOblastCities;
			}
		}
		return this.props.alphabet.regions;
	}

	getRenderImportantRegions() {
		return this.props.alphabet.cityImportant;
	}

	generateFirstLetters() {
		let objects = this.getRenderRegions();
		let classes = this.props.classes;
		let lastLetter = "";
		return objects.map((item, index) => {
			if (lastLetter !== item.name.substring(0, 1)) {
				lastLetter = item.name.substring(0, 1);
				let closureLetter = lastLetter;
				return (
					<div
						key={v4()}
						className={classNames(classes.footerItem, {
							[classes.isActive]: this.state.letterValue == lastLetter,
						})}
						onClick={() => this.setLettersValue(closureLetter)}
					>
						{lastLetter}
					</div>
				);
			}
		});
	}

	componentDidMount() {
		this.initCarousel();
	}

	initCarousel() {
		this.setState({
			...this.state,
			wasMount: true,
		});

		if (this.carousel) {
			setTimeout(() => {
				this.carousel.setDimensions();
			});
		}
	}

	generateObjects() {
		let {
			ApplicationModel: { currentRegion, searcheModel },
			data: {
				siteConfig: {
					contacts: { contact_phone },
				},
			},
			classes,
			text,
		} = this.props;

		function toNextColumn() {
			if (objectsInBlock.length) {
				blockInColumns.push(
					<div key={v4()} className={classes.block}>
						<div className={classes.blockNote}>{blockLetter}</div>
						{objectsInBlock}
					</div>
				);
			}

			blocksCounter = 0;
			columns.push(
				<div
					key={v4()}
					className={classNames(classes.col, {
						[classes.colRegion]: regions,
					})}
				>
					{blockInColumns}
				</div>
			);

			columnsCounter++;

			currentHeight = 0;
			objectsInBlock = [];
			blockInColumns = [];
		}

		function toNextBlock() {
			blockInColumns.push(
				<div key={v4()} className={classes.block}>
					<div className={classes.blockNote}>{blockLetter}</div>
					{objectsInBlock}
				</div>
			);
			currentHeight += defaultBlockMargin;
			blocksCounter++;
			objectsInBlock = [];
		}

		let columns = [];
		let columnsCounter = 0;
		let blockInColumns = [];
		let blocksCounter = 0;
		let objectsInBlock = [];
		let currentHeight = 0;
		let maxHeight = this.state.wasMount ? 640 : Number.POSITIVE_INFINITY;
		if (this.props.windowSizes.sm || this.props.windowSizes.xs)
			maxHeight = Number.POSITIVE_INFINITY;
		let itemHeight = 36;
		let defaultBlockMargin = 36;
		let importantBlockMargin = 72;
		let regions = true;
		// Список избранных регионов
		let objectsImportant = this.getRenderImportantRegions();
		// Список всех регионов
		let obj = this.getRenderRegions();
		// Список районов
		let objRegionsInDistricts = [];
		// Список подходящих по поиску регионов
		let objects = [];
		// Список подходящих по поиску районов
		let objectsRegionsInDistricts = [];

		let emptyText = (
			<div>
				{text.empty_select_region}
				<br />
				<div className={classes.phoneNumber}>{contact_phone}</div>
			</div>
		);

		// Начинаем искать регион
		if (this.props.searcheValue.length > 0) {
			objectsImportant = [...this.props.alphabet.cityImportant];
			objectsImportant = orderBy(objectsImportant, "name", "asc");
			if (this.props.searcheValue.length >= 3) {
				obj = [...this.props.alphabet.regions];
				objRegionsInDistricts = this.props.alphabet.regionsInDistricts;
			}

			obj = orderBy(obj, "name", "asc");

			const value = this.props.searcheValue.toLowerCase();

			let regexp = new RegExp(`(^${value}| ${value})`, "gi");

			objects = obj.filter((o) => {
				if (o.name.toLowerCase().match(regexp)) {
					return true;
				} else {
					return false;
				}
			});
			objectsImportant = objectsImportant.filter((item) => {
				if (item.name.toLowerCase().match(regexp)) {
					return true;
				} else {
					return false;
				}
			});
			if (
				this.props.searcheValue.length >= 3 &&
				this.props.alphabet.regionsInDistricts.length > 0
			) {
				objRegionsInDistricts = orderBy(objRegionsInDistricts, "name", "asc");
				objectsRegionsInDistricts = objRegionsInDistricts;
			}
		} else {
			objects = obj;
		}

		if (this.state.letterValue) {
			let regexp = new RegExp("^" + this.state.letterValue, "gi");
			objects = objects.filter((o) => {
				if (o.name.match(regexp)) {
					return true;
				} else {
					return false;
				}
			});
		}
		if (objectsImportant.length) {
			let importantBlock = objectsImportant.forEach((item, index) => {
				let newPath = "/";
				if (!this.props.defaultRegion || item.url !== this.props.defaultRegion.url) {
					newPath = newPath + item.url;
				}

				if (!!this.props.blockedPath && this.props.blockedPath !== "/") {
					newPath = newPath + this.props.blockedPath;
				}

				let element = React.cloneElement(
					this.props.element,
					{
						to: newPath.replace(/\/\//, "/"),
						onClick: () => this.props.onItemSelect(item),
						key: v4(),
						datatest: "main_region_choose",
						className: classes.blockItem,
					},
					item.name
				);
				objectsInBlock.push(element);
				currentHeight += itemHeight;
			});

			let siteCode = this.props.ApplicationModel.siteCode;
			if (!isMoscowSiteCode(siteCode)) {
				blockInColumns.push(
					<div key={v4()} className={classNames(classes.block, classes.blockImportant)}>
						<div className={classes.blockNote}>
							<span className="icon24 icon-star" />
						</div>
						{objectsInBlock}
					</div>
				);
			} else {
				blockInColumns.push(
					<>
						<div key={v4()} className={classNames(classes.block, classes.blockImportantMoskov)}>
							<div className={classes.blockNote}>
								<span className="icon24 icon-star" />
							</div>
							{objectsInBlock}
							<div
								className={classNames(
									//    classes.blockItem,
									classes.blockItemName
								)}
							>
								{text.POPULAR_CITIES}
							</div>
						</div>
					</>
				);
			}
			blocksCounter++;
			currentHeight += importantBlockMargin;
		}
		objectsInBlock = [];
		let blockLetter = objects.length > 0 ? objects[0].name.substring(0, 1) : "";
		for (var i = 0; i < objects.length; i++) {
			let item = objects[i];

			if (item.name.substring(0, 1) !== blockLetter) {
				toNextBlock();
				i--;
				blockLetter = item.name.substring(0, 1);
				continue;
			}
			if (currentHeight + itemHeight <= maxHeight) {
				let newPath = "/";
				if (!this.props.defaultRegion || item.url !== this.props.defaultRegion.url) {
					newPath = newPath + item.url;
				}
				if (!!this.props.blockedPath && this.props.blockedPath !== "/") {
					newPath = newPath + this.props.blockedPath;
				}

				let element = React.cloneElement(
					this.props.element,
					{
						to: newPath.replace(/\/\//, "/"),
						onClick: () => this.props.onItemSelect(item),
						key: v4(),
						datatest: "main_region_choose",
						className: classes.blockItem,
					},
					item.name
				);
				objectsInBlock.push(element);
				currentHeight += itemHeight;
				if (objectsRegionsInDistricts.length == 0) {
					if (i == objects.length - 1) {
						toNextColumn();
					}
				}
			} else {
				if (objectsRegionsInDistricts.length == 0) {
					toNextColumn();
					i--;
				}
			}
		}
		if (objectsRegionsInDistricts.length > 0) {
			/*********************************************************** */
			toNextBlock();
			blockLetter = "";
			objectsInBlock.push(
				<div className={classes.mainHeader} key={v4()}>
					Другие населенные пункты
				</div>
			);
			toNextBlock();

			blockLetter =
				objectsRegionsInDistricts.length > 0
					? objectsRegionsInDistricts[0].name.substring(0, 1)
					: "";
			for (var i = 0; i < objectsRegionsInDistricts.length; i++) {
				let item = objectsRegionsInDistricts[i];

				if (item.name.substring(0, 1) !== blockLetter) {
					toNextBlock();
					i--;
					blockLetter = item.name.substring(0, 1);
					continue;
				}
				if (currentHeight + itemHeight <= maxHeight) {
					let newPath = "/";
					if (!this.props.defaultRegion || item.url !== this.props.defaultRegion.url) {
						newPath = newPath + item.url;
					}
					if (!!this.props.blockedPath && this.props.blockedPath !== "/") {
						newPath = newPath + this.props.blockedPath;
					}

					let element = React.cloneElement(
						this.props.element,
						{
							to: newPath.replace(/\/\//, "/"),
							onClick: () => this.props.onItemSelect(item),
							key: v4(),
							datatest: "main_region_choose",
							className: classes.blockItem,
						},
						item.name
					);
					objectsInBlock.push(element);
					currentHeight += itemHeight;
					if (i == objectsRegionsInDistricts.length - 1) {
						toNextColumn();
					}
				} else {
					toNextColumn();
					i--;
				}
			}
		}
		if (!columns.length && !!blockInColumns.length) {
			columns.push(
				<div
					key={v4()}
					className={classNames(classes.col, {
						[classes.colRegion]: regions,
					})}
				>
					{blockInColumns}
				</div>
			);
		} else if (!columns.length && this.props.searcheValue.length >= 3) {
			searcheModel.sendRegionEmptySearch(
				currentRegion?.id,
				currentRegion?.name,
				this.props.searcheValue.toLowerCase()
			);
			return (
				<Container>
					<Row>
						<Col
							lg={{ size: 4, offset: 4 }}
							md={{ size: 4, offset: 4 }}
							sm={{ size: 4, offset: 4 }}
							xs={{ size: 6, offset: 3 }}
						>
							<EmptyStub
								header={text.OOPS}
								text={emptyText}
								icon={
									<span
										className="icon48 icon-hearts"
										style={{
											fontSize: "48px",
											color: "#5812fe",
										}}
									/>
								}
							/>
						</Col>
					</Row>
				</Container>
			);
		}

		let carouselLayout = chunk(columns, 3);
		return carouselLayout.map((item, index) => {
			return (
				<div key={v4()} className={classes.carouselItem}>
					{item}
				</div>
			);
		});
	}

	componentDidUpdate() {
		if (this.carousel) {
			this.carousel.setDimensions();
			this.carousel.goToSlide(0);
		}
	}

	render() {
		let decorator = [
			{
				component: (props) => <LeftArrow {...props} hideWhenEnd={true} />,
				position: "CenterLeft",
			},
			{
				component: (props) => <RightArrow {...props} hideWhenEnd={true} />,
				position: "CenterRight",
			},
		];
		let classes = this.props.classes;
		let text = this.props.text;
		let needSite = false;
		let siteCode = this.props.ApplicationModel.siteCode;

		let siteList = ["piteronline"];

		if (siteList.includes(siteCode)) {
			needSite = true;
		}

		return (
			<div className={classes.root}>
				<Container>
					<Row>
						<Col xs={12}>
							<div
								className={classNames(classes.wrapper, {
									[classes.notMount]: !this.state.wasMount,
									[classes.wrapper101]: !needSite,
								})}
							>
								<div className={classes.headerWrapper}>
									<div className={classes.header}>
										<span className={classes.mainHeader}>
											{`${text.CHOOSE_REGION_1} ${text.CHOOSE_REGION_2} ${text.CHOOSE_REGION_3} ${text.CHOOSE_REGION_4}`}
										</span>
									</div>
									<div className={classes.search}>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="23.906"
											height="24"
											viewBox="0 0 23.906 24"
										>
											<path
												d="M502.956,956a9,9,0,1,1,8.966-9A8.994,8.994,0,0,1,502.956,956Zm0-16a7,7,0,1,0,6.974,7A7,7,0,0,0,502.956,940ZM516.9,962a0.99,0.99,0,0,1-.7-0.293l-8.313-8.344a1,1,0,1,1,1.409-1.414l8.313,8.344A1,1,0,0,1,516.9,962Z"
												transform="translate(-494 -938)"
											/>
										</svg>

										<input
											type="text"
											className={classes.searchInput}
											placeholder="Введите первые 3 буквы"
											maxLength={100}
											value={this.props.searcheValue}
											onChange={(e) => this.findChangeHandler(e)}
										/>
									</div>
								</div>
								<div
									className={classNames(classes.citiesList, {
										[classes.otherCitiesList]: needSite,
									})}
								>
									{this.state.wasMount && (
										<Carousel
											ref={(carousel) => (this.carousel = carousel)}
											wrapAround={false}
											swiping={false}
											dragging={false}
											decorators={decorator}
										>
											{this.generateObjects()}
										</Carousel>
									)}
									{!this.state.wasMount && this.generateObjects()}
								</div>
								<div className={classes.footer}>
									{this.generateFirstLetters()}
									<div
										className={classNames(
											classes.footerItem,
											classes.footerItemAll,
											classes.isActive,
											{
												[classes.displayNone]: !this.state.letterValue && !this.props.searcheValue,
											}
										)}
										onClick={() => this.setLettersValue("")}
									>
										Назад
									</div>
								</div>
							</div>
						</Col>
					</Row>
				</Container>
				{React.cloneElement(this.props.linkComponent, {
					children: (
						<div className={classes.close}>
							<span className={"icon24 icon-close"} />
						</div>
					),
				})}
			</div>
		);
	}
}

export default withStyles(styles)(SwitchCityLayout);
